function ActiveLink() {
  return (
    <>
      <span
        className="hidden group-[.is-active]:block
        before:content-[''] before:absolute
        before:absolute before:w-5 before:h-5 
        before:bg-white 
        before:-left-5
        lg:before:-top-[20px] 
        lg:before:-right-0 
        lg:before:left-auto

        after:content-[''] after:absolute
        after:absolute after:w-5 after:h-5 after:bg-gray-25 
        after:rounded-tr-3xl
        after:-left-5
        lg:after:rounded-tr-none
        lg:after:left-auto
        lg:after:-top-[20px]
        lg:after:-right-0
        lg:after:rounded-br-3xl"></span>
      <span
        className="hidden group-[.is-active]:block
        before:content-[''] before:absolute
        before:absolute before:w-5 before:h-5 before:bg-white 

        before:bottom-auto
        before:-right-5
        lg:before:-bottom-[20px]
        lg:before:-right-0

        after:content-[''] after:absolute
        after:absolute after:w-5 after:h-5 after:bg-gray-25 

        after:bottom-atuo
        after:-right-5
        after:rounded-tl-3xl
        lg:after:-bottom-[20px]
        lg:after:-right-0
        lg:after:rounded-tl-none
        lg:after:rounded-tr-3xl"></span>
    </>
  );
}

// NavItem counter: open SyncUnits of the investor, hidden at 0 (screens.md §AppShell).
export function NavCounter({ count, label }) {
  if (!count) return null;
  return (
    <span
      data-testid="nav-counter"
      aria-label={label}
      className="ml-auto min-w-[18px] h-[18px] px-[5px] rounded-[9px] text-[11px] font-bold inline-flex items-center justify-center bg-accent-solid text-white"
    >
      {count}
    </span>
  );
}

export default ActiveLink;
